import { clearAppIconBadge } from '@/services/app-icon-badge';
import MessengerService from '@/services/messenger.service';

export type MessengerUnreadListener = (count: number) => void;

let unreadTotal = 0;
const listeners = new Set<MessengerUnreadListener>();

export function getMessengerUnreadTotal(): number {
  return unreadTotal;
}

export function formatMessengerUnread(count: number): string {
  if (count <= 0) return '';
  return count > 99 ? '99+' : String(count);
}

export function setMessengerUnreadTotal(count: number): void {
  const next = Math.max(0, Math.floor(count || 0));
  if (next === unreadTotal) return;
  unreadTotal = next;
  listeners.forEach(listener => listener(unreadTotal));
  if (next <= 0) {
    void clearAppIconBadge();
  }
}

export function subscribeMessengerUnread(listener: MessengerUnreadListener): () => void {
  listeners.add(listener);
  listener(unreadTotal);
  return () => {
    listeners.delete(listener);
  };
}

export async function refreshMessengerUnread(service = new MessengerService()): Promise<number> {
  try {
    const chats = await service.getChats();
    const total = chats.reduce((sum, chat) => sum + (chat.unreadCount || 0), 0);
    setMessengerUnreadTotal(total);
    return total;
  } catch {
    return unreadTotal;
  }
}
